// api开发环境地址
const config: Record<string, string> = {
  url: "http://njyx-plus-gateway.test.yuoucn.cn:50000/",
};
// api线上环境地址：域名包含test为测试环境，否则为生产环境
const currentHost = typeof window !== "undefined" ? window.location.host : "";
const isTestEnv = currentHost.includes("test");
if (process.env.NODE_ENV === "production" && !isTestEnv) {
  config.url = "https://njyx-plus-gateway.linkduoo.com/"; //生产环境地址
}

export default config;
